import angular = require("angular");
import listsRoutes = require("./lists.routes");
import listsController = require("./lists.controller");

export function initialize() {

    var listsModule = angular
        .module("app.lists", [
            "ui.router", "ui.router.upgrade"
    ]);

    listsRoutes.initialize(listsModule);
    listsController.initialize(listsModule);
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/lists/lists.module.ts